// extracted by mini-css-extract-plugin
export var animationContainer = "_j7-0";
export var footer = "_j7-1";
export var gray = "_j7-2";
export var lineItem = "_j7-3";
export var lineItemImage = "_j7-4";
export var lineItemInfo = "_j7-5";
export var lineItemText = "_j7-6";
export var lineItems = "_j7-7";
export var modalContent = "_j7-8";
export var options = "_j7-9";
export var orderName = "_j7-a";
export var refundAmount = "_j7-b";